export default class FiltroVendasPorPeriodo {
    constructor() {
        this.CodigoProduto = undefined;
        this.NomeProduto = undefined;
        this.DataInicioUltimaVenda = undefined;
        this.DataFinalUltimaVenda = undefined;
        this.ClienteId = undefined;
        this.UnidadeId = undefined;
        this.ConsultarDadosClienteAgrupador = false;
        this.OrdenarPorDataHora = undefined;
        this.OrdernarPorNumeroCartaProposta = undefined;
        this.EmLinha = undefined;
        this.Ordenacao = undefined;
        this.RepresentanteId = undefined;
    }
}